<template>
  <div class="w-full h-full">
    <v-chart
      :options="realtimeMonitoringData"
      :autoresize="true"
      class="w-full !h-full"
      :init-options="{ devicePixelRatio: 2 }"
      ref="pieChartRef"
    ></v-chart>
  </div>
</template>

<script>
export default {
  props: {
    realtimeMonitoringData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style>
</style>
